import React, { useState } from 'react';

function HomeDev() {
  const [isSongPlay, setIsSongPlay] = useState(false);
  const [isSpeakerDots, setIsSpeakerDots] = useState(false);
  const playStop = () => {
    setIsSongPlay((playStopStatus) => !playStopStatus);
    console.log(isSongPlay)
  };
  const SpeakerDots = () => {
    setIsSpeakerDots((speakerDotsStatus) => !speakerDotsStatus);
    console.log(isSpeakerDots)
  };
  return (

    <div className="d-contain">
      <div className="d-hero">
        <div className="d-hero_left">
          <div className="d-control">
            <div className="d-volume">
              <div className="d-volume_control">
                <div className="html-embed-2 w-embed">
                  <input id="“volumeslider”" type="range" min="0" max="100" step="1" value="80"></input>
                </div>
                <div className="d-volume_bar">
                  <div className="d-volume_bar-line"><img src={require('../images/svg/volume-lines.svg')}
                    alt="" className="d-bar_line-img" /></div>
                </div>
                <div className="d-volume_drag"><img src={require('../images/svg/volume-control.svg')}
                  data-w-id="4527514b-75b1-e848-a201-b45a0e5890ec" alt="" className="d-volume_drag-img" />
                </div>
              </div>
              <p class="d-controls_text is--last">VOLUME</p>
            </div>
            <div className={`d-controls ${isSongPlay ? "" : "no-click"}`}>
              <div className="d-button_contain"><a id="shuffle" href="#0" class="d-button w-inline-block">
                <div className="d-button_circle">
                  <div className="d-button_img">
                    <div data-animation-type="lottie" data-src="" data-loop="0" data-direction="1"
                      data-autoplay="0" data-is-ix2-target="1" data-renderer="svg"
                      data-default-duration="1.0010009602293968" data-duration="0"
                      class="d-social_icon"><svg xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 96 96" width="96" height="96"
                        preserveAspectRatio="xMidYMid meet">
                        <defs>
                          <clipPath id="__lottie_element_8">
                            <rect width="96" height="96" x="0" y="0"></rect>
                          </clipPath>
                          <filter id="__lottie_element_16" filterUnits="objectBoundingBox" x="0%"
                            y="0%" width="100%" height="100%">
                            <feComponentTransfer in="SourceGraphic">
                              <feFuncA type="table" tableValues="1.0 0.0"></feFuncA>
                            </feComponentTransfer>
                          </filter>
                          <mask id="__lottie_element_12" mask-type="alpha">
                            <g filter="url(#__lottie_element_16)">
                              <rect width="96" height="96" x="0" y="0" fill="#ffffff"
                                opacity="0"></rect>
                              <g transform="matrix(1.2017589807510376,-1.2444578409194946,0.17983494699001312,0.17366459965705872,-18.316513061523438,99.3980712890625)"
                                opacity="1">
                                <rect width="96" height="96" fill="#000000"></rect>
                              </g>
                            </g>
                          </mask>
                        </defs>
                        <g clip-path="url(#__lottie_element_8)">
                          <g mask="url(#__lottie_element_12)">
                            <g transform="matrix(1,0,0,1,14.601001739501953,14.601001739501953)"
                              opacity="1">
                              <g opacity="1"
                                transform="matrix(1,0,0,1,33.39899826049805,33.39899826049805)">
                                <path fill="rgb(255,255,255)" fill-opacity="1"
                                  d=" M33.14899826049805,10.357999801635742 C33.14899826049805,10.357999801635742 24.674999237060547,18.83099937438965 24.674999237060547,18.83099937438965 C24.674999237060547,18.83099937438965 -27.28700065612793,-33.14899826049805 -27.28700065612793,-33.14899826049805 C-27.28700065612793,-33.14899826049805 -33.14899826049805,-27.28700065612793 -33.14899826049805,-27.28700065612793 C-33.14899826049805,-27.28700065612793 18.83300018310547,24.695999145507812 18.83300018310547,24.695999145507812 C18.83300018310547,24.695999145507812 10.357999801635742,33.14899826049805 10.357999801635742,33.14899826049805 C10.357999801635742,33.14899826049805 33.14899826049805,33.14899826049805 33.14899826049805,33.14899826049805 C33.14899826049805,33.14899826049805 33.14899826049805,10.357999801635742 33.14899826049805,10.357999801635742z">
                                </path>
                              </g>
                            </g>
                          </g>
                          <g transform="matrix(1,0,0,1,14.601001739501953,14.601001739501953)"
                            opacity="1">
                            <g opacity="1"
                              transform="matrix(1,0,0,1,33.39899826049805,33.39899826049805)">
                              <path fill="rgb(255,255,255)" fill-opacity="1"
                                d=" M10.357999801635742,-33.14899826049805 C10.357999801635742,-33.14899826049805 18.83099937438965,-24.676000595092773 18.83099937438965,-24.676000595092773 C18.83099937438965,-24.676000595092773 -33.14899826049805,27.285999298095703 -33.14899826049805,27.285999298095703 C-33.14899826049805,27.285999298095703 -27.28700065612793,33.14899826049805 -27.28700065612793,33.14899826049805 C-27.28700065612793,33.14899826049805 24.695999145507812,-18.83300018310547 24.695999145507812,-18.83300018310547 C24.695999145507812,-18.83300018310547 33.14899826049805,-10.357999801635742 33.14899826049805,-10.357999801635742 C33.14899826049805,-10.357999801635742 33.14899826049805,-33.14899826049805 33.14899826049805,-33.14899826049805 C33.14899826049805,-33.14899826049805 10.357999801635742,-33.14899826049805 10.357999801635742,-33.14899826049805z">
                              </path>
                            </g>
                          </g>
                        </g>
                      </svg></div>
                  </div>
                </div>
              </a>
                <p class="d-controls_text">SHUFFLE</p>
              </div>
              <div className="d-button_contain"><a id="next" href="#0" class="d-button w-inline-block">
                <div className="d-button_circle">
                  <div className="d-button_img is--yellow">
                    <div data-animation-type="lottie" data-src="" data-loop="0" data-direction="1"
                      data-autoplay="0" data-is-ix2-target="1" data-renderer="svg"
                      data-default-duration="1.0010009602293968" data-duration="0"
                      class="d-social_icon"><svg xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 96 96" width="96" height="96"
                        preserveAspectRatio="xMidYMid meet">
                        <defs>
                          <clipPath id="__lottie_element_19">
                            <rect width="96" height="96" x="0" y="0"></rect>
                          </clipPath>
                          <filter id="__lottie_element_28" filterUnits="objectBoundingBox" x="0%"
                            y="0%" width="100%" height="100%">
                            <feComponentTransfer in="SourceGraphic">
                              <feFuncA type="table" tableValues="1.0 0.0"></feFuncA>
                            </feComponentTransfer>
                          </filter>
                          <mask id="__lottie_element_24" mask-type="alpha">
                            <g filter="url(#__lottie_element_28)">
                              <rect width="96" height="96" x="0" y="0" fill="#ffffff"
                                opacity="0"></rect>
                              <g transform="matrix(0.5,0,0,1,67.19999694824219,-0.000003814697265625)"
                                opacity="1">
                                <rect width="96" height="96" fill="#000000"></rect>
                              </g>
                            </g>
                          </mask>
                        </defs>
                        <g clip-path="url(#__lottie_element_19)">
                          <g mask="url(#__lottie_element_24)">
                            <g transform="matrix(1,0,0,1,14.649999618530273,14.650001525878906)"
                              opacity="1">
                              <g opacity="1"
                                transform="matrix(1,0,0,1,23.75,33.349998474121094)">
                                <path fill="rgb(255,255,255)" fill-opacity="1"
                                  d=" M-23.5,33.099998474121094 C-23.5,33.099998474121094 23.5,0 23.5,0 C23.5,0 -23.5,-33.099998474121094 -23.5,-33.099998474121094 C-23.5,-33.099998474121094 -23.5,33.099998474121094 -23.5,33.099998474121094z">
                                </path>
                              </g>
                            </g>
                          </g>
                          <g transform="matrix(1,0,0,1,69.8499984741211,14.64999771118164)"
                            opacity="1">
                            <g opacity="1" transform="matrix(1,0,0,1,5.75,33.400001525878906)">
                              <path fill="rgb(255,255,255)" fill-opacity="1"
                                d=" M-5.5,33.150001525878906 C-5.5,33.150001525878906 5.5,33.150001525878906 5.5,33.150001525878906 C5.5,33.150001525878906 5.5,-33.150001525878906 5.5,-33.150001525878906 C5.5,-33.150001525878906 -5.5,-33.150001525878906 -5.5,-33.150001525878906 C-5.5,-33.150001525878906 -5.5,33.150001525878906 -5.5,33.150001525878906z">
                              </path>
                            </g>
                          </g>
                        </g>
                      </svg></div>
                  </div>
                </div>
              </a>
                <p class="d-controls_text">NEXT</p>
              </div>
              <div className="d-button_contain"><a id="prev" href="#0" class="d-button w-inline-block">
                <div className="d-button_circle">
                  <div className="d-button_img is--blue">
                    <div data-animation-type="lottie" data-src="" data-loop="0" data-direction="1"
                      data-autoplay="0" data-is-ix2-target="1" data-renderer="svg"
                      data-default-duration="1.0010009602293968" data-duration="0"
                      class="d-social_icon"><svg xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 96 96" width="96" height="96"
                        preserveAspectRatio="xMidYMid meet">
                        <defs>
                          <clipPath id="__lottie_element_31">
                            <rect width="96" height="96" x="0" y="0"></rect>
                          </clipPath>
                          <filter id="__lottie_element_40" filterUnits="objectBoundingBox" x="0%"
                            y="0%" width="100%" height="100%">
                            <feComponentTransfer in="SourceGraphic">
                              <feFuncA type="table" tableValues="1.0 0.0"></feFuncA>
                            </feComponentTransfer>
                          </filter>
                          <mask id="__lottie_element_36" mask-type="alpha">
                            <g filter="url(#__lottie_element_40)">
                              <rect width="96" height="96" x="0" y="0" fill="#ffffff"
                                opacity="0"></rect>
                              <g transform="matrix(-0.5,0,0,-1,28.800003051757812,96.00000762939453)"
                                opacity="1">
                                <rect width="96" height="96" fill="#000000"></rect>
                              </g>
                            </g>
                          </mask>
                        </defs>
                        <g clip-path="url(#__lottie_element_31)">
                          <g mask="url(#__lottie_element_36)">
                            <g transform="matrix(-1,0,0,-1,81.3499984741211,81.3499984741211)"
                              opacity="1">
                              <g opacity="1"
                                transform="matrix(1,0,0,1,23.75,33.349998474121094)">
                                <path fill="rgb(255,255,255)" fill-opacity="1"
                                  d=" M-23.5,33.099998474121094 C-23.5,33.099998474121094 23.5,0 23.5,0 C23.5,0 -23.5,-33.099998474121094 -23.5,-33.099998474121094 C-23.5,-33.099998474121094 -23.5,33.099998474121094 -23.5,33.099998474121094z">
                                </path>
                              </g>
                            </g>
                          </g>
                          <g transform="matrix(-1,0,0,-1,26.150001525878906,81.35000610351562)"
                            opacity="1">
                            <g opacity="1" transform="matrix(1,0,0,1,5.75,33.400001525878906)">
                              <path fill="rgb(255,255,255)" fill-opacity="1"
                                d=" M-5.5,33.150001525878906 C-5.5,33.150001525878906 5.5,33.150001525878906 5.5,33.150001525878906 C5.5,33.150001525878906 5.5,-33.150001525878906 5.5,-33.150001525878906 C5.5,-33.150001525878906 -5.5,-33.150001525878906 -5.5,-33.150001525878906 C-5.5,-33.150001525878906 -5.5,33.150001525878906 -5.5,33.150001525878906z">
                              </path>
                            </g>
                          </g>
                        </g>
                      </svg></div>
                  </div>
                </div>
              </a>
                <p class="d-controls_text is--last">PREV</p>
              </div>
            </div>
          </div>
          <div className="d-welcome">
            <div className="d-overflow-hidden">
              <h1 class="is--h1">Yo! We’re <span class="is--red">ThreeSixtyEight.</span> Let’s jam together.</h1>
            </div>
          </div>
        </div>
        <div className={`d-hero_right ${isSongPlay ? "play" : ""}`}>
          <div data-animation-type="lottie" data-src="" data-loop="1" data-direction="1" data-autoplay="1"
            data-is-ix2-target="0" data-renderer="svg" data-default-duration="3.8" data-duration="0"
            class="d-power_lottie">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1127 1032" width="1127"
              height="1032" preserveAspectRatio="xMidYMid meet">
              <defs>
                <clipPath id="__lottie_element_43">
                  <rect width="1127" height="1032" x="0" y="0"></rect>
                </clipPath>
              </defs>
              <g clip-path="url(#__lottie_element_43)">
                <g transform="matrix(1,0,0,1,-0.5,0)" opacity="1">
                  <g opacity="1" transform="matrix(1,0,0,1,251,750.7429809570312)">
                    <path stroke-linecap="butt" stroke-linejoin="miter" fill-opacity="0"
                      stroke-miterlimit="10" stroke="rgb(247,88,73)" stroke-opacity="1" stroke-width="80"
                      d="M0 0"></path>
                  </g>
                </g>
                <g transform="matrix(1,0,0,1,0,0.3489990234375)" opacity="1">
                  <g opacity="1" transform="matrix(1,0,0,1,563.5,450)">
                    <path stroke-linecap="butt" stroke-linejoin="miter" fill-opacity="0"
                      stroke-miterlimit="4" stroke="rgb(247,88,73)" stroke-opacity="1" stroke-width="80"
                      d=" M363.5,-250 C363.5,-250 363.5,-250 363.5,-250"></path>
                  </g>
                </g>
              </g>
            </svg></div>
          <div className="d-power">
            <a id="play-btn" onClick={playStop} href="#0" className="pause">
              <img src={require('../images/svg/power-on.svg')} alt="" className="d-power_img" />
              <img src={require('../images/svg/power-off.svg')} alt="" className="d-power_img is--2" />
            </a>
          </div>
          <img src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014c42f1a01d0f36df24_switch.svg" alt="" class="c-switch"></img>
          <img alt="record" className="d-record rotate1" src={require('../images/svg/record.svg')} />
          <img src={require('../images/svg/hand.svg')} alt="" className="d-hand"></img>
          <div className="d-slide-box">
            <img src={require('../images/svg/bottom.svg')} alt="" className="d-slide_botton" />
            <img src={require('../images/svg/line.svg')} alt="" className="d-slide_middle" />
            <img src={require('../images/svg/top.svg')} alt="" className="d-slide_top" />
          </div>
        </div>
      </div>
      <div className="c-bottom_bg">
        <div className="c-form">
          <div className="c-form_heading">
            <h2>Get free TSE stickers</h2><img
              src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014cfb18713fb2725558_arrow.svg"
              alt="" className="c-form_arrow" />
          </div>
          <div className="c-form_block">
            <div className="c-form_wrap w-form">
              <form id="email-form" name="email-form" data-name="Email Form" class="c-form_main">
                <div data-animation="slide" data-hide-arrows="1" data-disable-swipe="1" data-nav-spacing="0"
                  data-duration="500" class="c-slider w-slider">
                  <div className="c-mask w-slider-mask">
                    <div className="c-slides w-slide">
                      <div className="c-form_contain">
                        <p class="is--form-text">My name is</p><input type="text"
                          class="c-form_field w-input" maxlength="256" name="Name" data-name="Name"
                          placeholder="(what do we call you?)" id="Name" required="" />
                      </div>
                    </div>
                    <div className="c-slides w-slide">
                      <div className="c-form_contain">
                        <p class="is--form-text">I get my snail mail at</p><input type="text"
                          class="c-form_field w-input" maxlength="256" name="Physical-Address"
                          data-name="Physical Address" placeholder="(US only - street, city, zip)"
                          id="Physical-Address" required="" />
                      </div>
                    </div>
                    <div className="c-slides w-slide">
                      <div className="c-form_contain">
                        <p class="is--form-text">Slide in my inbox at</p><input type="text"
                          class="c-form_field w-input" maxlength="256" name="Email" data-name="Email"
                          placeholder="(email)" id="Email" required="" />
                      </div>
                    </div>
                    <div className="c-slides is--last w-slide"><a href="http://threesixtyeight.com/"
                      target="_blank" class="c-work w-inline-block">
                      <div className="c-work_bg"></div><input type="submit" value="Get My Stickers"
                        data-wait="Please wait..." class="c-work_button is--submit w-button" />
                    </a></div>
                  </div>
                  <div className="left-arrow w-slider-arrow-left">
                    <div className="c-back_contain"><img
                      src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f0483b6d586e7e922143cdb_back-arrow.svg"
                      alt="" className="c-back" /></div>
                  </div>
                  <div className="c-button is--next w-slider-arrow-right">
                    <div className="c-button_circle">
                      <div className="c-button_img is--yellow"><img
                        src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f08688a0636dd3721dc67ff_next.svg"
                        alt="" className="c-social_icon" /></div>
                    </div>
                  </div>
                  <div className="slide-nav w-slider-nav w-round"></div>
                </div>
              </form>
              <div className="success-message w-form-done">
                <div className="c-success_fill">
                  <h4 class="is--success-heading">Boom! Bam!</h4>
                  <div className="c-success_p">
                    <p class="paragraph">Your stickers are coming in hot. Thanks for showing<span
                      class="c-success_img">       </span>love.</p>
                  </div>
                </div>
              </div>
              <div className="error-message w-form-fail">
                <div>Oops! Something went wrong while submitting the form.</div>
              </div>
            </div>
          </div>
        </div>
        <div className="c-footer_top">
          <div className="c-merch"></div>
          <div className="c-stickers">
            <div className="c-stickers_contain"><img
              src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f4fad4bc9d66e81a1958dc2_TurntableStickers-11.svg"
              loading="lazy" alt="" className="c-sticker is--3" /><img
                src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f4fad5cc067162f569b85a3_TurntableStickers-01.svg"
                loading="lazy" data-w-id="a0f96327-a37e-f646-dc9e-33e4f209a0db" alt="" className="c-sticker" /><img
                src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f4fad696e20ae5ab9717b99_TurntableStickers-02.svg"
                loading="lazy" alt="" className="c-sticker is--2" /><img
                src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f4fad97a12c02766b38dcb9_TurntableStickers-09.svg"
                loading="lazy" alt="" className="c-sticker is--11" /><img
                src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f4fadacb103d309f80828cd_TurntableStickers-08.svg"
                loading="lazy" alt="" className="c-sticker is--16" /><img
                src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f4fadbcc4f3d17f658ff5e2_TurntableStickers-04.svg"
                loading="lazy" alt="" className="c-sticker is--12" /><img
                src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f4fadff83fc1b0dc7d9b76f_TurntableStickers-03.svg"
                loading="lazy" alt="" className="c-sticker is--6" /><img
                src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f4fae37b835c9598fa8a0b5_TurntableStickers-12.svg"
                loading="lazy" alt="" className="c-sticker is--13" /><img
                src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f4fae458bbe24767ef6bd7d_TurntableStickers-13.svg"
                loading="lazy" alt="" className="c-sticker is--9" /><img
                src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f4fae5a2ee5899c37b6deaa_TurntableStickers-06.svg"
                loading="lazy" alt="" className="c-sticker is--14" /><img
                src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f4fae6bbb630648174fd964_TurntableStickers-05.svg"
                loading="lazy" alt="" className="c-sticker is--5" /><img
                src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f4fae7ce86d8b63b05f5d93_TurntableStickers-10.svg"
                loading="lazy" alt="" className="c-sticker is--4" /><img
                src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f4fae8ec75b29b334425e73_TurntableStickers-07.svg"
                loading="lazy" alt="" className="c-sticker is--7" /><img
                src="../assets.website-files.com/5efde90c257c12dbfe87c980/5efe014d8d4c70000275db76_sticker.png"
                loading="lazy"
                srcset="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014d8d4c70000275db76_sticker-p-500.png 500w, https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014d8d4c70000275db76_sticker-p-800.png 800w, https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014d8d4c70000275db76_sticker.png 999w"
                sizes="(max-width: 479px) 34vw, 8vw" alt="" className="c-sticker is--10" /></div>
          </div>
          <div className="c-speakers">
            <div className="c-speaker-large">
              <div className="c-speaker_contain">
                <div data-poster-url="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f3c48b3b33f89a9ecf3ae59_Coors-v3-poster-00001.jpg"
                  data-video-urls="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f3c48b3b33f89a9ecf3ae59_Coors-v3-transcode.mp4,https://assets.website-files.com/5efde90c257c12dbfe87c980/5f3c48b3b33f89a9ecf3ae59_Coors-v3-transcode.webm"
                  data-autoplay="true" data-loop="true" data-wf-ignore="true"
                  class="c-speaker_vid w-background-video w-background-video-atom">
                </div>
              </div>
              <div className="c-speaker_overlay">
                <a href="#" class="c-speaker_dots is--4 w-inline-block">
                  <img src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014c786067bb3c35938e_plus.svg" alt="" className="c-speaker_dot-img" />
                </a>
                <a href="#" class="c-speaker_dots is--3 w-inline-block">
                  <img src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014c786067bb3c35938e_plus.svg" alt="" className="c-speaker_dot-img" />
                </a>
                <a href="#" class="c-speaker_dots is--2 w-inline-block">
                  <img src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014c786067bb3c35938e_plus.svg" alt="" className="c-speaker_dot-img" />
                </a>
                <a data-w-id="1ea13c89-15f1-6a16-c372-6e8d98a66545" href="#" class="c-speaker_dots w-inline-block">
                  <img src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014c786067bb3c35938e_plus.svg" alt="" className="c-speaker_dot-img" />
                </a>
                <div className="c-random-class"></div>
                <img
                  src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f3c4830b33f89e7eaf3ad9a_speaker-large-red.svg"
                  alt="" className="c-speaker_large" />
              </div>
            </div>
            <div className="c-other-speakers">
              <div className="c-speaker_small"><img
                src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014ca60ef81d9c87ed01_speaker-small.svg"
                alt="" className="c-speaker_img" />
                <div className="c-speaker_dot"><img
                  src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014c786067bb3c35938e_plus.svg"
                  alt="" className="c-speaker_dot-img" /></div>
                <div className="c-speaker_dot is--2"><img
                  src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014c786067bb3c35938e_plus.svg"
                  alt="" className="c-speaker_dot-img" /></div>
                <div className="c-speaker_dot is--4"><img
                  src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014c786067bb3c35938e_plus.svg"
                  alt="" className="c-speaker_dot-img" /></div>
                <div className="c-speaker_dot is--3"><img
                  src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014c786067bb3c35938e_plus.svg"
                  alt="" className="c-speaker_dot-img" /></div>
              </div>
              <div className="c-speaker_small is--2nd"><img
                src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014ca60ef81d9c87ed01_speaker-small.svg"
                alt="" className="c-speaker_img" />
                <div className="c-speaker_dot"><img
                  src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014c786067bb3c35938e_plus.svg"
                  alt="" className="c-speaker_dot-img" /></div>
                <div className="c-speaker_dot is--2"><img
                  src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014c786067bb3c35938e_plus.svg"
                  alt="" className="c-speaker_dot-img" /></div>
                <div className="c-speaker_dot is--3"><img
                  src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014c786067bb3c35938e_plus.svg"
                  alt="" className="c-speaker_dot-img" /></div>
                <div className="c-speaker_dot is--4"><img
                  src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014c786067bb3c35938e_plus.svg"
                  alt="" className="c-speaker_dot-img" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-footer_bottom">
      </div>
    </div>


  );
}

export default HomeDev;